module.exports = __webpack_public_path__ + "static/media/get-in-touch.d77fef48.jpg";